import { Component, OnInit, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { RFI_COMMENT, RFI } from 'src/app/models/um/organization';
import { Document_Upload_File } from 'src/app/models/common';
import { serviceConstants } from 'src/app/constants/service.constants';
import * as $ from 'jquery';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-rfi-view-modal',
  templateUrl: './rfi-view-modal.component.html',
  styleUrls: ['./rfi-view-modal.component.scss']
})
export class RfiViewModalComponent implements OnInit {
  uploadedFiles = ["sample attachment"];
  formFields;
  rowData;
  @Input() public Content: any;
  // File upload
  formData: FormData;
  files: any[];
  APPLICATION_ID: string;
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  comments: RFI_COMMENT[] = [];
  comment: RFI_COMMENT;
  Status: string;
  rfi: any;
  userType: string;
  savedAttachments = [];
  document_attach_list: Document_Upload_File[] = [];
  rfiViewForm = new UntypedFormGroup({
    comments: new UntypedFormControl(null)
  })
  @ViewChild('fileInput') fileInput: ElementRef;
  content: any = {};
  heading: string;
  action: Subject<any> = new Subject();
  permission: string = "";
  closebutton: string = "Cancel";
  constructor(
    private adminService: AdministrationSummaryService,
    public modalRef: NgbActiveModal,
    private commonService: CommonService) {
    this.files = [];
    this.uploadInput = new EventEmitter<any>();
  }

  ngOnInit() {

    this.permission = this.commonService.getPagePermission("IST16").toLowerCase();

    if (this.permission == null || this.permission == undefined || this.permission == '') {
      const intervalId = setInterval(() => {
        this.permission = this.commonService.getPagePermission("IST16").toLowerCase();
        if (this.permission != null && this.permission != undefined && this.permission != '') {
          clearInterval(intervalId);
        }
      }, 1000);
    }

    // this.permission = "";
    // var lper = this.commonService.getPagePermission("IST16");
    // if (lper != null && lper) {
    //   this.permission = lper.toLowerCase();
    // }

    this.rfi = new RFI();
    this.rfi.RECORD_STATE = 0;
    this.userType = this.Content.content.userType;
    this.APPLICATION_ID = this.Content.content.appid;
    if (this.Content.heading == "View") {
      this.closebutton = "Close";
    }

    this.adminService.getRFIByID('api/rfi/getrficomment/' + this.Content.content.id).subscribe((result) => {
      this.comments = result;
    });

    // Ensure Content is ready
    // this.adminService.getRFIByID('api/rfi/getrfibyid/' + this.Content.content.id).subscribe(result => {
    //   this.rfi = result;
    // });

    this.rfi = this.Content.content.rfiDetails;

    this.adminService.getRFIByID('api/rfi/getcomment/' + this.Content.content.id).subscribe((result) => {
      if (result === null || result === undefined) {
        this.comment = new RFI_COMMENT();
        this.comment.ID = '';
      }
      else
        this.comment = result;
      this.setForm(this.comment);
    });

  }

  setForm(comment: RFI_COMMENT): void {
    this.rfiViewForm = new UntypedFormGroup({
      comments: new UntypedFormControl(comment.COMMENTS),
    })

    if (this.permission == "view") {
      this.rfiViewForm.disable();
    }

    this.document_attach_list = [];
    if (comment.Attachments !== undefined && comment.Attachments !== null) {
      for (let i = 0; i < comment.Attachments.length; i++) {
        let uploadFile = new Document_Upload_File();
        uploadFile.ID = comment.Attachments[i].ID;
        uploadFile.DOCUMENT_NAME = comment.Attachments[i].FileName;
        uploadFile.Status = "Edit";
        this.document_attach_list.push(uploadFile);
      }
    }
  }

  getForm(): RFI_COMMENT {
    const formModel = this.rfiViewForm.value;
    let rficomment = new RFI_COMMENT();
    rficomment = {
      ID: this.comment.ID || '',
      TITLE: this.comment.TITLE || '',
      RFI_ID: this.Content.content.id,
      COMMENTS: formModel.comments || '',
      CreatedDateStr: '',
      Days: 0,
      RaisedBy: '',
      IsSubmit: false,
      Attachments: []
    };
    return rficomment;
  }

  save(Status) {
    if (this.validateControls()) {
      let formAttachments = new FormData();
      const data = this.getForm();

      if (Status == 2) {
        data.IsSubmit = true;
      }

      data["USER_TYPE"] = this.Content.content.userType;
      if (this.document_attach_list !== null && this.document_attach_list.length > 0) {
        for (let i = 0; i < this.document_attach_list.length; i++) {
          this.document_attach_list[i].TRANSACTION_ID = ("" + (i + 1));
          formAttachments.append(("" + (i + 1)), this.document_attach_list[i].File);
        }
      };

      data["ExistingAttachments"] = this.document_attach_list;
      data["APPLICATION_ID"] = this.APPLICATION_ID;
      formAttachments.append("ScreenData", JSON.stringify(data));

      this.adminService.addRFIComment(formAttachments).subscribe(result => {
        if (result.Status === 0) {
          if (Status == 1) {
            this.commonService.SuccessBanner('RFI ' + this.rfi.TITLE + ' details updated successfully');
          }
          else {
            this.commonService.SuccessBanner('RFI ' + this.rfi.TITLE + ' submitted successfully');
          }
          this.modalRef.close();
        }
        else {
          this.commonService.ValidationBanner(result.Message);
        }
      })
    }
  }

  cancel() {
    this.modalRef.close();
  }

  /* savesubmit() {
    if (this.validateControls()) {
      let formAttachments = new FormData();
      const data = this.getForm();
      data.IsSubmit = true;
      data["USER_TYPE"] = this.Content.content.userType;
      if (this.document_attach_list !== null && this.document_attach_list.length > 0) {
        for (let i = 0; i < this.document_attach_list.length; i++) {
          this.document_attach_list[i].TRANSACTION_ID = ("" + (i + 1));
          formAttachments.append(("" + (i + 1)), this.document_attach_list[i].File);
        }
      }
      data["ExistingAttachments"] =  this.document_attach_list;
      data["APPLICATION_ID"] = this.APPLICATION_ID;
      formAttachments.append("ScreenData", JSON.stringify(data));

      this.adminService.addRFIComment(formAttachments).subscribe(result => {
        if (result.Status === 0) {
          this.commonService.SuccessBanner('RFI ' + this.rfi.TITLE + ' updated/submitted successfully');
          
          this.modalRef.hide();
        }
        else {
          this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: result.Message } } });
        }
      })
    }
  } */

  showFiles() {
    let files = '';
    this.uploadedFiles = [];

    for (let i = 0; i < this.files.length; i++) {
      files += this.files[i].name;
      if (!(this.files.length - 1 === i)) {
        files += ',';
      }

    }

    for (let i = 0; i < this.files.length; i++) {
      let newAttachment = this.files[i].name;
      this.uploadedFiles.push(newAttachment);
    }

    return files;
  }

  startUpload(): void {
    const event: any = {
      type: 'uploadAll',
      url: 'your-path-to-backend-endpoint',
      method: 'POST',
      data: { foo: 'bar' },
    };
    this.files = [];
    this.uploadInput.emit(event);
  }

  GetAttachmentData() {
    //this.summaryService.GetMasterScreenData("api/ISTFileAttachments/GetDcumentData?RecordID=" + this.Content.content.id).subscribe(summary => {
    //  this.AttachmentModal.patchValue(summary);
    //  this.savedAttachments = summary["Attachments"];
    //});
  }

  uploadchange(event): void {
    if (this.document_attach_list == undefined || this.document_attach_list == null) {
      this.document_attach_list = [];
    }
    // let hasUnFormat = false;
    let Isexe = false;
    let Is5oMB = false;

    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      var file = event.target.files[i].name;
      var ext = file.match(/\.([^\.]+)$/)[1];
      var filesize = event.target.files[i].size;

      if (file != null && (ext == 'exe')) {
        Isexe = true;
        //this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 50MB");
      }
      else if (file != null && ((filesize > 52428800))) {
        Is5oMB = true;
      }
      else {
        uploadFile.ID = this.commonService.getUniqueId();
        uploadFile.DOCUMENT_NAME = event.target.files[i].name;
        uploadFile.File = event.target.files[i];
        uploadFile.Status = "Add";
        let hasValue = this.document_attach_list.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
        if (hasValue.length > 0) {
          this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
        } else {
          this.document_attach_list.push(uploadFile);
          // this.cdRef.detectChanges();
          console.log(this.document_attach_list);
        }
      }
    }
    if (Is5oMB && Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details and Accepts maximum file size 50MB");
    }

    else if (Is5oMB) {
      this.commonService.ValidationBanner("Accepts maximum file size 50MB");
    }

    else if (Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details")
    }

    event.target.value = '';
  }

  downloadFile(ID) {
    let url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + ID;
    window.open(url);
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }

  isAllowedExtensionFile(Filename) {
    return this.commonService.isAllowedExtension(Filename);
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.rfiViewForm.value;
    if (formData.comments === null || formData.comments === "" || formData.comments === undefined) {
      $("#comments").addClass("ng-touched ng-invalid validate-error");
      $("#comments").removeClass("ng-untouched ng-valid");
      message += "Please enter comments<br/>";
      isValid = false;
    } else {
      $("#comments").addClass("ng-untouched ng-valid");
      $("#comments").removeClass("ng-touched ng-invalid validate-error");
    }

    if (!isValid)
      this.commonService.ValidationBanner("Please enter comments");
    //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: message } } });
    return isValid;
  }

  DeleteUpload(file): void {

    if (file.Status == "Add" || file.Status == "Edit") {
      let code = file.ID;
      this.document_attach_list = this.document_attach_list.filter(function (sec) {
        return sec.ID != code;
      }, code);

      if (file.Status == "Edit") {
        this.document_attach_list.forEach(data => {
          if (data.ID == file.ID) {
            file.Status = "Delete";
            console.log(file.Status);
          }
        })
      }

      // let code = file.ID;
      // if (file.Status == "Add") {

      //   this.document_attach_list = this.document_attach_list.filter(function (sec) {
      //     return sec.ID != code;
      //   }, code);    
      // }
      // else {
      //   this.commonService.CheckIsFileIsRefereancedInReviw(code).subscribe((x)=>{
      //     if(x["Status"]==2 && x["Data"]==false)
      //     {
      //       this.commonService.ValidationBanner(x["Message"]);
      //     }
      //     else{
      //       this.document_attach_list = this.document_attach_list.filter(function (sec) {
      //         return sec.ID != code;
      //       }, code);
      //       file.Status = "Delete";
      //     }
      //   });

      // }
    }
  }

  OnTextAreachange(event) {
    console.log(event);
    this.rfiViewForm.controls['comments'].setValue(event.target.value);
  }

}
